<div class="header">
  <span
    *ngIf="campaign && campaign.isEditable"
    class="top-action-icon top-action-icon--no-corner"
    (click)="deletePostDialog()"
  >
    <img src="/assets/images/trash-bin.svg" width="16" />
  </span>
  <span class="top-action-icon" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </span>
  <h2 mat-dialog-title class="title-orange">
    {{ "brand.campaign.contentCalendar.updatePostTitle" | translate }}
  </h2>
  <div
    (click)="checkLink($event)"
    class="can-not-save-post-warning"
    *ngIf="showCanNotCreateGoogleAdWarning()"
    [innerHTML]="
      'brand.campaign.contentCalendar.canNotCreateGoogleAdsWarning' | translate
    "
  ></div>
</div>
<mat-dialog-content>
  <div class="post-container">
    <ng-container *ngIf="post.isFacebookPost">
      <app-facebook-post-mock-up *ngIf="showFacebookPreview()" [post]="post" />
      <app-instagram-post-mock-up
        *ngIf="showInstagramPreview()"
        [post]="post"
      />
    </ng-container>
    <app-google-ad-mock-up *ngIf="post.isGoogleAd" [post]="post" />
    <app-linkedin-post-mock-up *ngIf="post.isLinkedInPost" [post]="post" />
    <div class="carousel-footer-container">
      <div class="carousel-footer">
        <div class="carousel-footer-preview-text">
          <ng-container *ngIf="showMediaPreviewButton()">
            <img
              *ngIf="facebookPreviewType === FacebookPreviewType.Facebook"
              src="/assets/images/icons/ic_facebook.svg"
            />
            <img
              *ngIf="facebookPreviewType === FacebookPreviewType.Instagram"
              src="/assets/images/icons/ic_instagram.svg"
            />
            <span *ngIf="facebookPreviewType === FacebookPreviewType.Facebook">
              {{ "shared.facebookPreview" | translate }}
            </span>
            <span *ngIf="facebookPreviewType === FacebookPreviewType.Instagram">
              {{ "shared.instagramPreview" | translate }}
            </span>
          </ng-container>
        </div>
        <div class="carousel-footer-dots"></div>
        <div class="carousel-footer-button">
          <button
            *ngIf="showMediaPreviewButton()"
            (click)="toggleFacebookPreviewType()"
            class="carousel-footer-button-preview"
          >
            <span>{{ "shared.preview" | translate }}</span>
            <img
              *ngIf="facebookPreviewType === FacebookPreviewType.Facebook"
              src="/assets/images/icons/ic_instagramContent.svg"
            />
            <img
              *ngIf="facebookPreviewType === FacebookPreviewType.Instagram"
              src="/assets/images/icons/ic_facebookContent.svg"
            />
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="post-attributes">
    <section class="time-selection">
      <div class="time">
        <label class="selector-title">{{
          "shared.chooseTime" | translate
        }}</label>
        <div class="selectors">
          <mat-form-field>
            <mat-label>{{ "shared.hours" | translate }}</mat-label>
            <mat-select
              [disabled]="!campaign || !campaign.isEditable"
              [(ngModel)]="scheduledPublishDateHour"
            >
              <mat-option *ngFor="let hour of hours" [value]="hour">
                {{ hour }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ "shared.minutes" | translate }}</mat-label>
            <mat-select
              [disabled]="!campaign || !campaign.isEditable"
              [(ngModel)]="scheduledPublishDateMinute"
            >
              <mat-option *ngFor="let minute of minutes" [value]="minute">
                {{ minute }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="timezone">
        <label class="selector-title">{{
          "shared.chooseTimezone" | translate
        }}</label>
        <mat-form-field>
          <mat-label>{{ "shared.timezone" | translate }}</mat-label>
          <mat-select
            [disabled]="!campaign || !campaign.isEditable"
            [(ngModel)]="scheduledPublishDateTimezone"
          >
            <mat-option *ngFor="let timezone of timezones" [value]="timezone">
              {{ timezone }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>
    <section *ngIf="post.isFacebookPost" class="promo-ads">
      <span class="title"
        >{{ "shared.promoAds" | translate }}
        <app-tooltip
          text="{{
            'brand.campaign.contentCalendar.promoAdsToolTip'
              | translate
                : {
                    numberOfAds: campaign.maxAdsCampaignPartner
                  }
          }}"
        />
      </span>
      <mat-checkbox
        (change)="calculateNumberOfAdsCreated()"
        [disabled]="
          !campaign ||
          !campaign.isEditable ||
          (!willBecomeAd &&
            numberOfAdsCreated >= campaign.maxAdsCampaignPartner)
        "
        [(ngModel)]="willBecomeAd"
        name="use-promo-ads-check"
      >
        {{ "brand.campaign.contentCalendar.usePromoAdsInThisPost" | translate }}
        <span class="amount-of-ads">
          ({{ numberOfAdsCreated }}
          {{
            "brand.campaign.contentCalendar.useOutOfAMaximumAmountOff"
              | translate
          }}
          {{ campaign.maxAdsCampaignPartner }})</span
        >
      </mat-checkbox>
    </section>
    <section *ngIf="post.isFacebookPost" class="dark-post">
      <span class="title"
        >{{ "shared.darkPost" | translate }}
        <app-tooltip
          text="{{
            'brand.campaign.contentCalendar.darkPostToolTip' | translate
          }}"
        />
      </span>
      <mat-checkbox
        [disabled]="isDarkPostDisabled()"
        [(ngModel)]="isDarkPost"
        name="dark-post-check"
      >
        {{
          "brand.campaign.contentCalendar.onlyUseThisPostForAnAd" | translate
        }}
      </mat-checkbox>
    </section>
  </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="campaign && campaign.isEditable">
  <button class="btn btn--transparent" (click)="closeDialog()">
    {{ "shared.cancel" | translate }}
  </button>
  <button class="btn btn--primary button-confirm" (click)="onSave()">
    {{ "shared.saveChanges" | translate }}
  </button>
</mat-dialog-actions>
